import apiClient from './config';

const token = localStorage.getItem('token');
const headers = token ? { 'Authorization': token } : {};

const categoryApi = {
  // Get categories with search and pagination
  getCategories: async (params = {}) => {
    try {
      const defaultParams = {
        search: '',
        page_size: 10,
        page_number: 1,
        ...params
      };
      
      const response = await apiClient.get('/category', { params: defaultParams, ...(token && { headers }) });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    try {
      const response = await apiClient.get(`/${categoryId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default categoryApi; 